enum Device {
  DESKTOP = "DESKTOP",
  MOBILE = "MOBILE",
  MOBILE_LANDSCAPE = "MOBILE_LANDSCAPE",
  MOBILE_LG = "MOBILE_LG",
  MOBILE_LG_LANDSCAPE = "MOBILE_LG_LANDSCAPE",
  TABLET = "TABLET",
  TABLET_LANDSCAPE = "TABLET_LANDSCAPE",
}

export default Device;
